<div class="main-container mat-typography mat-body">

  <div class="button-container top-buttons">
    <a href="javascript:void(0)" (click)="navBack()">
      <span class="material-symbols-outlined">arrow_back</span>
      <span>BACK</span>
    </a>
    <a href="javascript:void(0)" (click)="submit(medicationForm)">
      <span>NEXT</span>
      <span class="material-symbols-outlined">arrow_forward</span>
    </a>
  </div>

  <!-- Main Container -->
  <mat-card appearance="outlined" class="find-medication-card">

    <mat-card-header>
      <mat-card-title>
        <h2 class='med-title'>{{componentHeader}} <small>{{componentSubTitle}}</small></h2>
      </mat-card-title>
    </mat-card-header>

    <mat-card-content>
      <!-- Sub-Title -->
      <div class="description-container">
        {{ componentDescription }}
        <br/>
        <em>
          Fields marked with an asterisk (<span style="color: #a71919;">*</span>) are required.
        </em>
      </div>

      <!-- Search -->
      <div class="medication-information-component">
        <form [formGroup]="autocompleteForm">
          <!-- AUTO-COMPLETE LOOKUP (start) -->
          <mat-form-field appearance="outline" class="autocomplete-field" floatLabel="">
            <!-- Drug Lookup, search -->
            <mat-label>
              {{ autoCompleteSearchLabel }}
            </mat-label>
            <input
              type="text"
              matInput
              formControlName="userSearch"
              [matAutocomplete]="auto"
              #autoTrigger
              (focus)="triggerPanelOpen()"
              />

              <!-- Drug Lookup, results -->
              <mat-autocomplete
                class="medication-information-component-autocomplete"
                #auto="matAutocomplete"
                panelWidth="auto"
                >
                @for (drug of autoCompleteLookupResults | autocompleteDrugFilter; track drug) {
                  <mat-option
                    [value]="drug.DrugName"
                    (click)="addDrugToSelected(drug)"
                    >
                    <div class="autocomplete-item">
                      <div class="autocomplete-drug-name">
                        <span>{{ drug.DrugName }}</span>
                      </div>
                      <div class="autocomplete-add-button">
                        <span class="material-symbols-outlined">add_circle</span>
                      </div>
                    </div>
                  </mat-option>
                }
              </mat-autocomplete>
            </mat-form-field>
            <!-- AUTO-COMPLETE LOOKUP (end) -->
          </form>

          <form
            [formGroup]="medicationForm"
            [connect]="['componentStates', 'MedicationInformation', 'medicationForm']"
            >
            <!-- Selected Drugs (start) -->
            <div formArrayName="selectedMedications">
              @for (drug of selectedMedications.controls; track drug; let index = $index) {
                <mat-card
                  appearance="outlined"
                  class="drug-info mat-elevation-z2"
                  formGroupName="{{ index }}"
                  >
                  <mat-card-header>
                    <div class="information-title">
                      @if (!medicationForm.controls.selectedMedications.controls[index].controls.useGenericVersion.value) {
                        <h3 class="drug-name">
                          {{ drug.value.drug.DrugName }}
                        </h3>
                      }
                      @if (medicationForm.controls.selectedMedications.controls[index].controls.useGenericVersion.value) {
                        <h3 class="drug-name">
                          {{ drug.value.drug.GenericDrugName }} <small>({{ drug.value.drug.DrugName }})</small>
                        </h3>
                      }
                      <!-- Remove Item -->
                      <div class="form-control-container autocomplete-remove-button">
                        <div class="center-inside">
                          <span
                            class="material-symbols-outlined"
                            tabindex="0"
                            role="button"
                            (click)="removeDrugFromSelected(drug.value.drug, index)">
                            close
                          </span>
                        </div>
                      </div>
                    </div>
                  </mat-card-header>
                  <mat-card-content>
                    @if (genericNote && shouldShowGenericCheckbox(drug.value.drug) && !medicationForm.controls.selectedMedications.controls[index].controls.useGenericVersion.value) {
                      <div>
                        <small>{{ genericNote }}</small>
                      </div>
                    }
                    <div class="information-body">
                      @if (shouldShowGenericCheckbox(drug.value.drug)) {
                        <div class="checkbox-container">
                          <div class="brand" [ngClass]="{ 'active' : !medicationForm.controls.selectedMedications.controls[index].controls.useGenericVersion.value }">
                            <span>Brand</span>
                          </div>
                          <mat-slide-toggle formControlName="useGenericVersion" (change)="toggleGeneric(medicationForm.controls['selectedMedications'], index)"></mat-slide-toggle>
                          <div class="generic" [ngClass]="{ 'active' : medicationForm.controls.selectedMedications.controls[index].controls.useGenericVersion.value }">
                            <span>Generic</span>
                          </div>
                        </div>
                      }
                      <div class="form-control-container">
                        <mat-form-field appearance="outline">
                          <mat-label>
                            {{ dosageSelectionLabel }}
                          </mat-label>
                          <mat-select formControlName="selectedDosage" required appUniqueDose>
                            @for (dosage of drug.value.drug.Dosages; track dosage) {
                              <mat-option [value]="dosage.DosageID">
                                {{ dosage.LabelName }}
                              </mat-option>
                            }
                          </mat-select>
                          <mat-error>{{
                            selectedMedications[index]
                            .get('selectedDosage')
                            .hasError('dose-not-unique')
                            ? 'Medications MUST have a unique dose'
                            : 'Please make a selection'
                          }}</mat-error>
                        </mat-form-field>
                      </div>
                      @if (shouldShowPackageDropdown(drug.value.selectedDosage,drug.value.drug.Dosages)) {
                        <div class="form-control-container">
                          <mat-form-field appearance="outline">
                            <mat-label>
                              {{ packageSizeSelectionLabel }}
                            </mat-label>
                            <mat-select formControlName="selectedPackage" required>
                              @for (
                                package of whichPackagesToShow(
                                drug.value.selectedDosage,
                                drug.value.drug.Dosages
                                )
                                ; track
                                package) {
                                <mat-option
                                  [value]="package.ReferenceNDC"
                                  >
                                  {{ package.selectedPackage }}
                                  {{ package.PackageSizeUnitOfMeasure }}
                                  {{ package.PackageDescription }}
                                  @if (package.PackageQuantity > 0) {
                                    <span>( Pack Size: {{ package.PackageQuantity }} )</span>
                                  }
                                </mat-option>
                              }
                            </mat-select>
                            <mat-hint>
                              <small>Amount of drug taken during given frequency</small>
                            </mat-hint>
                            <mat-error>{{ packageSizeSelectionError }}</mat-error>
                          </mat-form-field>
                        </div>
                      }
                      <div class="form-control-container quantity-field">
                        <mat-form-field appearance="outline">
                          <mat-label>Quantity</mat-label>
                          <input type="number" matInput formControlName="dosageQuantity" placeholder="Quantity" required />
                          @if (selectedMedications[index].get('dosageQuantity').hasError('required')) {
                            <mat-error>Please enter a value</mat-error>
                          }
                          @if (selectedMedications[index].get('dosageQuantity').hasError('min')) {
                            <mat-error>Quantity cannot be less than 1</mat-error>
                          }
                        </mat-form-field>
                      </div>
                      <div class="form-control-container frequency-field">
                        <mat-form-field appearance="outline">
                          <mat-label>
                            {{ frequencySelectionLabel }}
                          </mat-label>
                          <mat-select formControlName="frequency" required>
                            @for (frequency of dosageFrequencies; track frequency) {
                              <mat-option [value]="frequency">
                                {{ frequency }}
                              </mat-option>
                            }
                          </mat-select>
                          <mat-hint>
                            <small>{{ frequencySelectionHint }}</small>
                          </mat-hint>
                          <mat-error>Please make a selection</mat-error>
                        </mat-form-field>
                      </div>
                      <!-- @TODO
                      either force the form to not load until values from the state exist (not currently possible)
                      or force invalid state on controls (currently, controls are null, maybe define them in some way?)
                      -->
                      @if (drug.valid && drug.value.selectedDosage) {
                        <div class="friendly-readout">
                          <span class="label">
                            Calculated Dosages per Month
                          </span>
                          <span class="value">&nbsp;{{
                            drugLookupServiceProxy.getCalculatedDosageQuantityPerMonth(
                            drug.value.drug.Dosages,
                            drug.value.selectedDosage,
                            drug.value.selectedPackage,
                            drug.value.dosageQuantity,
                            drug.value.frequency
                            )
                            }}
                          </span>
                        </div>
                      }
                    </div>
                  </mat-card-content>
                </mat-card>
              }
            </div>
            <!-- Selected Drugs (end) -->
          </form>
        </div>
      </mat-card-content>

    </mat-card>
  </div>

  <div class="button-container">
    <a href="javascript:void(0)" (click)="navBack()">
      <span class="material-symbols-outlined">arrow_back</span>
      <span>BACK</span>
    </a>
    <a href="javascript:void(0)" (click)="submit(medicationForm)">
      <span>NEXT</span>
      <span class="material-symbols-outlined">arrow_forward</span>
    </a>
  </div>
